import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import {useTranslation} from "react-i18next";
import {ISSUES_GLOBAL} from "../../locales/namespaces";
import {withPermissionHOC} from "../../../permission/components/permissionHOC/permissionHOC";
import {view_po} from "../../../../helpers/rights/rights";
import Box from "@mui/material/Box";
import {useEffect, useState} from "react";
import {List, ListItemButton, ListItemText, Paper} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import {API} from "../../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../../helpers/errorHandling";
import useUserData from "../../../../hooks/user/useUserData";
import {mapFilters} from "../../pages/index";
import {LoadingButton} from "@mui/lab";

const SelectedPODialog = ({
                              open,
                              onClose,
                              setOpenPO,
                              setPoQuickView,
                              rowSelectionModel,
    setRowSelectionModel,
    dataManager,
    filters,
                          }) => {
    const {t} = useTranslation(ISSUES_GLOBAL)
    const {token} = useUserData()
    const [inExisting, setInExisting] = useState(false);
    const [selectedPO, setSelectedPO] = useState(null);
    const[openData, setOpenData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleListOpen = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: API + '/en/custom/purchase_sales/search',
            data:{
                type:"PO"
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        }).then(res => {
            setOpenData(res.data.data)
            setInExisting(true)
            setLoading(false);
            console.log('data',res.data.data)
        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })
        })
    }


    const handleOpenPODialog = () => {
        setOpenPO(true)
        setInExisting(false)
        onClose();
    }
    const handleClose = () => {
        onClose()
        setInExisting(false)
    }
    const handleAddInExisting = (id,code) => {

        const result = rowSelectionModel.map((item) => ({
            id: item,
            value: 0,
        }));

        axios({
            method: 'post',
            url: API + '/en/custom/purchase/workOrder/add',
            data:{
                id:id,
                issues:result
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        }).then(res => {
            const onSuccess=()=>{
                setPoQuickView({
                    open:true,
                    Code:code
                })
                onClose()
                setRowSelectionModel([])
            }
            const params = {...mapFilters(filters) };
            dataManager(params, onSuccess)

        }).catch(error => {
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })
        })
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 6
                }}
            >
                {t("Do you want to add in already existing PO or create new?")}

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box sx={{display: "flex", justifyContent: "space-between", gap: 2, mb: 2}}>
                    <LoadingButton
                        loading={loading}
                        onClick={() => handleListOpen()}
                        variant="outlined"
                        color="warning"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            py: 1.2,
                            fontWeight: 600,
                            textTransform: "none",
                        }}
                    >
                        {t("Add in already existing PO")}
                    </LoadingButton>

                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleOpenPODialog}
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            py: 1.2,
                            fontWeight: 600,
                            textTransform: "none",
                            boxShadow: "none",
                        }}
                    >
                        {t("Create P.O")}
                    </Button>
                </Box>

                {inExisting && (
                    <Paper
                        elevation={0}
                        sx={{
                            mt: 2,
                            p: 1,
                            borderRadius: 3,
                            border: "1px solid",
                            borderColor: "divider",
                            bgcolor: "#fafafa",
                        }}
                    >
                        <Typography
                            sx={{
                                px: 1.5,
                                pt: 1,
                                pb: 1,
                                fontSize: 14,
                                fontWeight: 700,
                                color: "text.secondary",
                            }}
                        >
                            {t("Select a P.O")}
                        </Typography>

                        <List sx={{p: 0, display: "flex", flexDirection: "column", gap: 1}}>
                            {openData.map((item) => (
                                <ListItemButton
                                    key={item.id}
                                    selected={selectedPO === item.id}
                                    onClick={() => {
                                        setSelectedPO(item.id);
                                        handleAddInExisting(item.id,item.Code)
                                        // console.log("Selected PO:", item);
                                    }}
                                    sx={{
                                        borderRadius: 2,
                                        alignItems: "flex-start",
                                        border: "1px solid",
                                        borderColor:
                                            selectedPO === item.id ? "warning.main" : "transparent",
                                        bgcolor:
                                            selectedPO === item.id ? "warning.50" : "#fff",
                                        px: 2,
                                        py: 1.5,
                                        transition: "all 0.2s ease",
                                        "&:hover": {
                                            bgcolor: "#fff7ed",
                                            borderColor: "warning.light",
                                        },
                                        "&.Mui-selected": {
                                            bgcolor: "#fff7ed",
                                        },
                                        "&.Mui-selected:hover": {
                                            bgcolor: "#ffedd5",
                                        },
                                    }}
                                >
                                    <Box sx={{width: "100%"}}>
                                        <Typography
                                            sx={{
                                                fontSize: 15,
                                                fontWeight: 700,
                                                color: "text.primary",
                                                mb: 0.5,
                                            }}
                                        >
                                            {item.Code}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                color: "text.secondary",
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            {item.Description}
                                        </Typography>
                                    </Box>
                                </ListItemButton>
                            ))}
                        </List>
                    </Paper>
                )}
            </DialogContent>

            <Divider/>
        </Dialog>
    );
};

export default withPermissionHOC(SelectedPODialog, [view_po]);
